<template xmlns="">
  <v-card dark class="d-flex flex-column" style="background-color: #121212; min-height: 100vh">
    <v-toolbar dark color="#1e1e1e" flat style="border-bottom: 1px solid #333; position: sticky; top: 0; z-index: 100">
      <v-btn icon large @click="checkChanges">
        <v-icon large>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="text-h5 font-weight-bold white--text ml-2">
        {{ exerciseEdit ? "Übung bearbeiten" : "Neue Übung" }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" height="48" class="text-h6 font-weight-bold px-6 black--text" @click="validateForm"> Speichern </v-btn>
    </v-toolbar>

    <div style="overflow-y: auto; flex-grow: 1; padding-bottom: 100px">
      <div style="background-color: #1e1e1e; padding: 20px">
        <v-card dark color="#2a2a2a" class="elevation-0 mx-auto" max-width="800" style="border: 1px dashed #555">
          <slim-cropper v-if="loaded" style="height: 300px; width: 100%" :options="slimOptionsExercise">
            <img v-if="form.picture" :src="'/img/uebungen/' + form.picture" alt="" />
            <input type="file" accept="image/*" />
          </slim-cropper>
          <div v-if="!form.picture && loaded" class="text-center pa-4 grey--text text-h6">
            <v-icon large color="grey" class="mb-2">mdi-camera-plus</v-icon><br />
            Tippe hier, um ein Übungsbild hochzuladen
          </div>
        </v-card>
      </div>

      <v-form ref="form" lazy-validation @submit.prevent="preventReload" class="pa-4 mx-auto" style="max-width: 800px">
        <div class="mb-8">
          <h2 class="white--text font-weight-bold text-h4 mb-4 d-flex align-center">
            <v-icon large color="primary" class="mr-3">mdi-dumbbell</v-icon> Grunddaten
          </h2>
          <v-text-field
            label="Übungstitel"
            v-model="form.title"
            :rules="rules.title"
            counter="30"
            outlined
            dark
            background-color="#1e1e1e"
            class="text-h6 mb-4"
            height="60"></v-text-field>

          <v-select
            v-if="availableTags"
            v-model="form.tags"
            :items="availableTags"
            deletable-chips
            return-object
            item-value="_id"
            item-text="name"
            multiple
            label="Tags (z.B. Brust, Bizeps...)"
            outlined
            dark
            background-color="#1e1e1e"
            class="text-h6"
            height="60">
            <template v-slot:selection="{ item }">
              <v-chip
                dark
                color="primary"
                class="black--text font-weight-bold mt-2"
                close
                @click:close="form.tags.splice(form.tags.indexOf(item), 1)">
                {{ item.name }}
              </v-chip>
            </template>
          </v-select>
        </div>

        <v-divider dark class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h4 d-flex align-center">
              <v-icon large color="primary" class="mr-3">mdi-format-list-numbered</v-icon> Anleitung
            </h2>
            <v-btn color="primary" height="48" class="text-h6 black--text px-6 font-weight-bold" @click="openManualDialog(-1)">
              <v-icon left>mdi-plus-thick</v-icon> SCHRITT
            </v-btn>
          </div>

          <div
            v-if="!form.manual || form.manual.length === 0"
            class="text-center pa-8 grey--text text-h5"
            style="border: 2px dashed #333; border-radius: 8px">
            Noch keine Schritte hinzugefügt.
          </div>

          <v-card
            v-for="(manual, index) in form.manual"
            :key="index + 'manual'"
            dark
            color="#1e1e1e"
            class="mb-4 d-flex flex-row align-center elevation-2"
            style="border: 1px solid #333; cursor: pointer"
            @click="openManualDialog(index)">
            <div style="width: 100px; height: 100px; background-color: #121212" class="d-flex justify-center align-center position-relative">
              <v-img v-if="manual.picture" :src="'/img/uebungen/' + manual.picture" cover height="100%" width="100%"></v-img>
              <v-icon v-else large color="grey">mdi-image</v-icon>
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: var(--v-primary-base);
                  color: black;
                  padding: 4px 12px;
                  font-weight: bold;
                  font-size: 20px;
                  border-bottom-right-radius: 8px;
                ">
                {{ index + 1 }}
              </div>
            </div>
            <div class="pa-4 flex-grow-1">
              <div class="text-h6 white--text">{{ manual.description || "Keine Beschreibung" }}</div>
            </div>
            <div class="pa-4">
              <v-icon large color="grey">mdi-pencil</v-icon>
            </div>
          </v-card>
        </div>

        <v-divider dark class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h4 d-flex align-center">
              <v-icon large color="primary" class="mr-3">mdi-cog</v-icon> Gerät
            </h2>
            <v-btn color="primary" height="48" class="text-h6 black--text px-6 font-weight-bold" @click="generalExerciseSettingsDialog = true">
              <v-icon left>mdi-plus-thick</v-icon> SETTING
            </v-btn>
          </div>

          <v-row class="ma-0">
            <v-col cols="12" md="6" v-for="(setting, index) in form.general_exercise_settings" :key="index + 'g-setting'" class="pa-2">
              <v-card dark color="#1e1e1e" class="pa-4 elevation-2 d-flex justify-space-between align-center" style="border-left: 6px solid #1976d2">
                <div>
                  <div class="text-h6 font-weight-bold white--text">{{ setting.text }}</div>
                  <div class="text-subtitle-1 grey--text">
                    {{ setting.input }} <span v-if="setting.selections && setting.selections.length">({{ setting.selections.length }} Optionen)</span>
                  </div>
                </div>
                <v-btn icon large color="red" @click="deleteExerciseSetting(setting, 0, 'Device')">
                  <v-icon large>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <v-divider dark class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h4 d-flex align-center">
              <v-icon large color="primary" class="mr-3">mdi-repeat</v-icon> Sätze
            </h2>
            <v-btn color="primary" height="48" class="text-h6 black--text px-6 font-weight-bold" @click="setExerciseSettingsDialog = true">
              <v-icon left>mdi-plus-thick</v-icon> SETTING
            </v-btn>
          </div>

          <v-row class="ma-0">
            <v-col cols="12" md="6" v-for="(setting, index) in form.set_exercise_settings" :key="index + 's-setting'" class="pa-2">
              <v-card dark color="#1e1e1e" class="pa-4 elevation-2 d-flex justify-space-between align-center" style="border-left: 6px solid #4caf50">
                <div>
                  <div class="text-h6 font-weight-bold white--text">{{ setting.text }}</div>
                  <div class="text-subtitle-1 grey--text">{{ setting.input }}</div>
                </div>
                <v-btn icon large color="red" @click="deleteExerciseSetting(setting, 0, 'set')">
                  <v-icon large>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </div>

    <v-dialog v-model="manualDialog" max-width="600px" dark persistent>
      <v-card color="#1e1e1e">
        <v-toolbar dark color="#121212" flat>
          <v-toolbar-title class="text-h5 font-weight-bold white--text">{{ getManualFormTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="abortManual"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-card dark color="#2a2a2a" class="elevation-0 mx-auto mb-6" style="border: 1px dashed #555">
            <slim-cropper :key="manualForm.picture" v-if="loaded" style="height: 250px; width: 100%" :options="slimOptionsManual">
              <img v-if="manualForm.picture" :src="'/img/uebungen/' + manualForm.picture" alt="" />
              <input type="file" accept="image/*" />
            </slim-cropper>
          </v-card>
          <v-text-field
            v-model="manualForm.description"
            label="Beschreibung des Schrittes"
            outlined
            dark
            background-color="#121212"
            class="text-h6"
            height="60"
            @keydown.enter.prevent="saveManual"></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn v-if="manualForm.index >= 0" color="red" text large @click="deleteManual">Löschen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey" text large @click="abortManual">Abbrechen</v-btn>
          <v-btn color="primary" class="black--text font-weight-bold" large @click="saveManual">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="generalExerciseSettingsDialog" max-width="600px" dark persistent>
      <v-card color="#1e1e1e">
        <v-card-title class="text-h5 font-weight-bold white--text pt-6">Geräteeinstellung</v-card-title>
        <v-card-text class="pt-4">
          <v-combobox
            v-model="exerciseSetting"
            :search-input.sync="exerciseSettingSearch"
            item-text="text"
            return-object
            item-value="text"
            label="Was wird eingestellt? (z.B. Sitz)"
            :items="availableDeviceExerciseSettingsFiltered"
            outlined
            dark
            background-color="#121212"
            class="text-h6 mb-4"
            height="60"></v-combobox>
          <v-select
            v-if="exerciseSetting.text"
            v-model="exerciseSetting.input"
            label="Eingabe-Typ"
            item-text="text"
            item-value="input"
            :items="exerciseSettingInputPossibilities"
            outlined
            dark
            background-color="#121212"
            class="text-h6 mb-4"
            height="60"></v-select>
          <v-combobox
            v-model="exerciseSetting.selections"
            v-if="exerciseSetting.input && exerciseSetting.input === 'selection'"
            :search-input.sync="selectionPossibilitiesSearch"
            label="Auswahlmöglichkeiten (mit Enter bestätigen)"
            multiple
            small-chips
            outlined
            dark
            background-color="#121212"
            class="text-h6"></v-combobox>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text large @click="abortSettingForm">Abbrechen</v-btn>
          <v-btn color="primary" class="black--text font-weight-bold" large @click="saveGeneralSetting">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="setExerciseSettingsDialog" max-width="600px" dark persistent>
      <v-card color="#1e1e1e">
        <v-card-title class="text-h5 font-weight-bold white--text pt-6">Satzeinstellung</v-card-title>
        <v-card-text class="pt-4">
          <v-combobox
            v-model="exerciseSetting"
            :search-input.sync="exerciseSettingSearch"
            item-text="text"
            return-object
            item-value="text"
            label="Was wird pro Satz erfasst? (z.B. Gewicht)"
            :items="availableSetExerciseSettingsFiltered"
            outlined
            dark
            background-color="#121212"
            class="text-h6 mb-4"
            height="60"></v-combobox>
          <v-select
            v-if="exerciseSetting.text"
            v-model="exerciseSetting.input"
            label="Eingabe-Typ"
            item-text="text"
            item-value="input"
            :items="exerciseSettingInputPossibilities"
            outlined
            dark
            background-color="#121212"
            class="text-h6 mb-4"
            height="60"></v-select>
          <v-combobox
            v-model="exerciseSetting.selections"
            v-if="exerciseSetting.input && exerciseSetting.input === 'selection'"
            :search-input.sync="selectionPossibilitiesSearch"
            label="Auswahlmöglichkeiten (mit Enter bestätigen)"
            multiple
            small-chips
            outlined
            dark
            background-color="#121212"
            class="text-h6"></v-combobox>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text large @click="abortSettingForm">Abbrechen</v-btn>
          <v-btn color="primary" class="black--text font-weight-bold" large @click="saveSetSetting">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="400" dark>
      <v-card color="#1e1e1e">
        <v-card-title class="text-h5 font-weight-bold white--text pt-6">Wirklich löschen?</v-card-title>
        <v-card-text class="text-h6 grey--text mt-2"> Möchtest Du "{{ deletingExerciseSetting.text }}" unwiderruflich entfernen? </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text large @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="red" class="white--text font-weight-bold" large @click="deleteExerciseSetting(deletingExerciseSetting, 1)">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saveWarningDialog" max-width="500" dark>
      <v-card color="#1e1e1e">
        <v-card-title class="text-h5 font-weight-bold white--text pt-6">Achtung!</v-card-title>
        <v-card-text class="text-h6 grey--text mt-2">Du hast ungespeicherte Änderungen. Trotzdem schließen?</v-card-text>
        <v-card-actions class="pa-4">
          <v-btn color="red" text large @click="$emit('close')">Verwerfen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="black--text font-weight-bold" large @click="validateForm">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import api from "@/api"
import { mapGetters, mapActions, mapState } from "vuex"
import Slim from "@/plugins/slimImage/slim/slim.vue"

export default {
  name: "deviceExerciseForm",
  components: {
    "slim-cropper": Slim,
  },
  data() {
    return {
      slimOptionsExercise: {
        ratio: "4:3",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        dataJpegCompression: 30,
        label: "",
        service: this.uploadPicture,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },
      slimOptionsManual: {
        ratio: "4:3",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        dataJpegCompression: 30,
        label: "",
        service: this.uploadManualImage,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },

      form: {
        _id: null,
        title: "",
        tags: [],
        picture: "",
        general_exercise_settings: [],
        set_exercise_settings: [],
        manual: [],
      },
      oldForm: {},

      exerciseSetting: { text: null, input: null, selections: [] },
      deleteDialog: false,
      saveWarningDialog: false,
      deletingExerciseSetting: { text: "", input: "" },

      selectionPossibilitiesSearch: "",
      exerciseSettingSearch: "",
      exerciseSettingInputPossibilities: [
        { text: "Text", input: "text" },
        { text: "Zahl", input: "number" },
        { text: "Auswahl", input: "selection" },
      ],
      availableExerciseSettings: [
        { text: "Programm", input: "text" },
        { text: "Thema", input: "text" },
        { text: "Level", input: "text" },
        { text: "Dehnmethode", input: "text" },
        { text: "Herzfrequenz", input: "text" },
        { text: "Ausdauermethode", input: "text" },
        { text: "Watt", input: "number" },
        { text: "Geschwindigkeit", input: "number" },
        { text: "Umdrehungen pro Minute", input: "number" },
        { text: "Kalorien", input: "number" },
        { text: "Pause", input: "text" },
        { text: "Dauer", input: "number" },
        { text: "Notiz", input: "text" },
        { text: "Gewicht", input: "number" },
        { text: "Max Wiederholungen", input: "number" },
        { text: "Min Wiederholungen", input: "number" },
        { text: "Sätze", input: "number" },
        { text: "Lehne", input: "number" },
        { text: "Sitz", input: "text" },
        { text: "Winkel", input: "text" },
        { text: "Rolle", input: "text" },
        { text: "Polster", input: "text" },
        { text: "Position", input: "text" },
        { text: "Platte", input: "text" },
        { text: "Wiederstand", input: "text" },
        { text: "Band", input: "text" },
        { text: "Höhe Box", input: "text" },
        { text: "Griffe", input: "text" },
        { text: "Höhe", input: "number" },
        { text: "Ball", input: "text" },
        { text: "Variante", input: "text" },
        { text: "Bandstärke", input: "text" },
        { text: "Pad", input: "text" },
      ],

      generalExerciseSettingsDialog: false,
      setExerciseSettingsDialog: false,
      manualDialog: false,
      deleteType: "",
      loaded: false,
      manualForm: { picture: "", description: "" },
      availableTags: null,
      rules: {
        title: [(v) => !!v || "Dieses Feld wird benötigt", (v) => v.length <= 30 || "Der Titel ist zu lang"],
      },
    }
  },
  async created() {
    this.availableTags = await api.fetchExerciseTags()

    if (this.exerciseEdit) {
      // Wichtig: Kopie erstellen, damit wir im Store nicht live editieren
      this.form = JSON.parse(JSON.stringify(this.exerciseEdit))
    }

    this.oldForm = JSON.stringify(this.form)
    this.loaded = true
  },
  methods: {
    ...mapActions("deviceStore", ["updateExercise", "createExercise"]),

    checkChanges() {
      if (this.oldForm !== JSON.stringify(this.form)) {
        this.saveWarningDialog = true
      } else {
        this.$emit("close")
      }
    },

    preventReload(event) {
      event.preventDefault()
    },

    validateForm() {
      if (this.$refs.form.validate()) {
        if (this.exerciseEdit) {
          this.updateExercise(this.form)
        } else {
          this.createExercise(this.form)
        }

        this.$emit("close")
      }
    },

    // --- BILDER UPLOADS ---
    uploadPicture(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      let uploadimg = { art: "device_exercise", formData: formData }
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            this.form.picture = data.name
            success(data)
          }
        })
        .catch(failure)
    },

    uploadManualImage(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      let uploadimg = { art: "device_exercise_manual", formData: formData }
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            this.manualForm.picture = data.name
            success(data)
          }
        })
        .catch(failure)
    },

    // --- SCHRITTE (MANUALS) ---
    openManualDialog(index) {
      if (index >= 0) {
        this.manualForm = JSON.parse(JSON.stringify(this.form.manual[index]))
        this.manualForm.index = index
      } else {
        this.manualForm = { picture: "", description: "", index: -1 }
      }
      this.manualDialog = true
    },
    saveManual() {
      if (this.manualForm.index >= 0) {
        let index = this.manualForm.index
        delete this.manualForm.index
        this.$set(this.form.manual, index, this.manualForm)
      } else {
        delete this.manualForm.index
        this.form.manual.push(this.manualForm)
      }
      this.abortManual()
    },
    abortManual() {
      this.manualDialog = false
      this.manualForm = { picture: "", description: "", index: -1 }
    },
    deleteManual() {
      this.form.manual.splice(this.manualForm.index, 1)
      this.abortManual()
    },

    // --- SETTINGS ---
    abortSettingForm() {
      this.generalExerciseSettingsDialog = false
      this.setExerciseSettingsDialog = false
      this.exerciseSetting = { input: null, text: null, selections: [] }
    },
    saveGeneralSetting() {
      if (!this.exerciseSetting.selections || !this.exerciseSetting.selections.length) delete this.exerciseSetting.selections
      this.form.general_exercise_settings.push({ ...this.exerciseSetting })
      this.abortSettingForm()
    },
    saveSetSetting() {
      if (!this.exerciseSetting.selections || !this.exerciseSetting.selections.length) delete this.exerciseSetting.selections
      this.form.set_exercise_settings.push({ ...this.exerciseSetting })
      this.abortSettingForm()
    },
    deleteExerciseSetting(es, status, type) {
      if (status === 0) {
        this.deleteType = type
        this.deletingExerciseSetting = es
        this.deleteDialog = true
      } else {
        if (this.deleteType === "Device") {
          this.form.general_exercise_settings = this.form.general_exercise_settings.filter((setting) => setting.text !== es.text)
        } else {
          this.form.set_exercise_settings = this.form.set_exercise_settings.filter((setting) => setting.text !== es.text)
        }
        this.deleteDialog = false
      }
    },
  },
  computed: {
    ...mapState("deviceStore", ["exerciseEdit"]),

    getManualFormTitle() {
      return this.manualForm.index >= 0 ? `Schritt ${this.manualForm.index + 1} bearbeiten` : "Neuen Schritt hinzufügen"
    },
    availableDeviceExerciseSettingsFiltered() {
      let activated = this.form.general_exercise_settings || []
      return this.availableExerciseSettings.filter((setting) => !activated.find((a) => a.text === setting.text))
    },
    availableSetExerciseSettingsFiltered() {
      let activated = this.form.set_exercise_settings || []
      return this.availableExerciseSettings.filter((setting) => !activated.find((a) => a.text === setting.text))
    },
  },
}
</script>

<style>
/* Überschreibe den Slim-Cropper Button damit er für ältere User besser sichtbar ist */
.slim-btn {
  background-color: #1976d2 !important;
  color: white !important;
  font-size: 16px !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
}
</style>
